import { ApiAddress } from "@/services/apis"
import { Equipment } from "@/services/project/equipment/equipment.model"
import request from "@/services/request"

export interface EquipmentMenu {
  id: number
  name: string
  equipment: Equipment.Base[]
}

export interface FlowEquipmentMenu extends EquipmentMenu {
  equipment: Equipment.Info[]
}

export function getEquipmentMenus(): Promise<EquipmentMenu[]> {
  return request.get(ApiAddress.EQUIPMENT_MENUS)
}

export function getFlowMenus(): Promise<FlowEquipmentMenu[]> {
  return request.get(ApiAddress.FLOW_MENUS)
}

export function createEquipmentMenus(body: {name: string, equipment: number[]}): Promise<EquipmentMenu> {
  return request.post(ApiAddress.EQUIPMENT_MENUS, body)
}

export function updateEquipmentMenus(id: number, body: {name: string, equipment: number[]}): Promise<EquipmentMenu> {
  return request.put(ApiAddress.EQUIPMENT_MENU, body, {params: {id}})
}

export function deleteEquipmentMenu(id: number): Promise<EquipmentMenu> {
  return request.delete(ApiAddress.EQUIPMENT_MENU, {params: {id}})
}

export const OrganizationEquipmentMenuService = {
  getEquipmentMenus: (orgId: number): Promise<EquipmentMenu[]> => {
    return request.get(ApiAddress.ORGANIZATION_EQUIPMENT_MENUS, { params: { orgId } })
  },
  createEquipmentMenus: (orgId: number, body: {name: string, equipment: number[]}): Promise<EquipmentMenu> => {
    return request.post(ApiAddress.ORGANIZATION_EQUIPMENT_MENUS, body, { params: { orgId } })
  },
  updateEquipmentMenus: (id: number, body: {name: string, equipment: number[]}): Promise<EquipmentMenu> => {
    return request.put(ApiAddress.EQUIPMENT_MENU, body, { params: { id } })
  },
  deleteEquipmentMenu: (id: number): Promise<EquipmentMenu> => {
    return request.delete(ApiAddress.EQUIPMENT_MENU, { params: { id } })
  }
}
